var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"faqConfirm"},[_c('div',{staticClass:"faqConfirm__title"},[_vm._v("よくある質問")]),_c('iframe',{staticClass:"faqConfirm__content",attrs:{"title":"FAQ","src":_vm.faqUrl}})])}
var staticRenderFns = []

export { render, staticRenderFns }